// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add to FaqStyle.module.css */
.rich-editor {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 10px 0;
}

.toolbar {
  background: #f5f5f5;
  padding: 5px;
  border-bottom: 1px solid #ddd;
}

.toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 10px;
  font-size: 14px;
}

.editor-content {
  width: 100%;
  min-height: 150px;
  padding: 10px;
  border: none;
  resize: vertical;
  font-family: inherit;
  font-size: 14px;
}
.modalOverlay {
  width: 100%;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: white;
}
.modal {
  width: 100%;
  text-align: left;
}
.input_wrap {
  margin: 20px auto;
}
.description_wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.modalConfirm {
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  font-size: 1rem;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.modalConfirm:hover {
  background-color: #24943e;
}
.modalCancel {
  padding: 10px 20px;
  background-color: #b7b7b7;
  color: white;
  font-size: 1rem;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.modalCancel:hover {
  background-color: #8a8888;
}
.descriptionArea {
  max-height: 200px;
  height: auto;
  overflow: auto;
}
.modalActions {
  display: flex;
  gap: 10px;
}
.input_box {
  width: 100%;
  padding: 10px 14px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.input_box:focus {
  border-color: #4a90e2;
}
`, "",{"version":3,"sources":["webpack://./src/Component/NewCreateAppF/rich-editor.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* Add to FaqStyle.module.css */\n.rich-editor {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin: 10px 0;\n}\n\n.toolbar {\n  background: #f5f5f5;\n  padding: 5px;\n  border-bottom: 1px solid #ddd;\n}\n\n.toolbar button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin-right: 10px;\n  font-size: 14px;\n}\n\n.editor-content {\n  width: 100%;\n  min-height: 150px;\n  padding: 10px;\n  border: none;\n  resize: vertical;\n  font-family: inherit;\n  font-size: 14px;\n}\n.modalOverlay {\n  width: 100%;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background-color: white;\n}\n.modal {\n  width: 100%;\n  text-align: left;\n}\n.input_wrap {\n  margin: 20px auto;\n}\n.description_wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.modalConfirm {\n  padding: 10px 20px;\n  background-color: #28a745;\n  color: white;\n  font-size: 1rem;\n  border-radius: 6px;\n  border: none;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n.modalConfirm:hover {\n  background-color: #24943e;\n}\n.modalCancel {\n  padding: 10px 20px;\n  background-color: #b7b7b7;\n  color: white;\n  font-size: 1rem;\n  border-radius: 6px;\n  border: none;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n.modalCancel:hover {\n  background-color: #8a8888;\n}\n.descriptionArea {\n  max-height: 200px;\n  height: auto;\n  overflow: auto;\n}\n.modalActions {\n  display: flex;\n  gap: 10px;\n}\n.input_box {\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  outline: none;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.input_box:focus {\n  border-color: #4a90e2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
